import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "decoration-blue",
  "use": "decoration-blue-usage",
  "viewBox": "0 0 250 39",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 39\" id=\"decoration-blue\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M136.281 8.584l5.253.804 5.638.858c39.723 6.034 80.234 12.187 102.388 28.381H.341c3.622-10.058 9.21-18.709 16.797-24.814C41.75-5.9 87.418 1.097 136.28 8.584z\" fill=\"#62B3FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol